const createdTime = (recipe) => {
  const value = Date.parse(recipe?.created_at || "");
  return Number.isFinite(value) ? value : null;
};

const stableKey = (recipe) => `${recipe?.id || ""}\u0000${recipe?.name || ""}`;

export const compareRecipesNewestFirst = (left, right) => {
  const leftTime = createdTime(left);
  const rightTime = createdTime(right);
  if (leftTime !== null && rightTime !== null && leftTime !== rightTime) return rightTime - leftTime;
  if (leftTime !== null && rightTime === null) return -1;
  if (leftTime === null && rightTime !== null) return 1;
  return stableKey(left).localeCompare(stableKey(right), "ru");
};

export const sortRecipesNewestFirst = (recipes) => [...recipes].sort(compareRecipesNewestFirst);
